export const DEFAULT_JOB_THEME = {
  dashboardTheme: {
    backgroundColor: '#f7f9fc',
    baseColor: '#6224c6',
    textColor: '#fff',
    opacity: 1,
  },
  entities: {
    topics: {},
    creators: {},
    brands: {},
  },
}
